<template>

<b-container class="v-center text-center  mt-5">
    <b-row>
        <b-col>
            <h1 class="display-4">404 - Página no encontrada</h1>
            <p class="lead">Lo sentimos, la página que buscas no existe.</p>
            <b-button variant="primary" :href="mainSite">Ir al Sitio Principal</b-button>
        </b-col>
    </b-row>
</b-container>

</template>

<script>
import {publicWebURI} from '@/apiConfig'
export default {
    name: 'NotFound',
    props: {
        mainSite: {
            type: String, 
            default: ( ) =>  publicWebURI
        }
    }
}
</script>